import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import { useClickOutside } from '../../../../utils/hooks/useClickOutside.js';
import s from './index.module.scss.js';

const Popper = ({
  id,
  children,
  trigger,
  triggerClassName,
  isOpen,
  options,
  setIsOpen,
  onTriggerClick = () => {
  },
  style,
  className
}) => {
  const [open, setOpen] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(
    null
  );
  const { styles, attributes } = usePopper(
    referenceElement,
    popperElement,
    options || {
      modifiers: [
        { name: "preventOverflow", options: { padding: 13 } },
        { name: "offset", options: { offset: [16, 13] } },
        { name: "shift", options: { enabled: true } },
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top", "right"]
          }
        }
      ]
    }
  );
  const close = () => {
    popperElement?.classList.add("close");
    setTimeout(() => {
      setOpen(false);
      setIsOpen(false);
    }, 250);
  };
  useClickOutside({ current: popperElement }, (e) => {
    if (e.target.closest(".rkc-base-popup")) return;
    if (e.target.closest(".popper-portal")) return;
    if (e.target.dataset.accordionControl) return;
    close();
  });
  const onKeyDownHanlder = (e) => {
    if (e.target.closest(".rkc-base-popup")) return;
    if (e.target.closest(".popper-portal")) return;
    if (e.target.dataset.accordionControl) return;
    if (e.key === "Escape") {
      close();
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", onKeyDownHanlder, {
      passive: true
    });
    return () => {
      window.removeEventListener("keydown", onKeyDownHanlder);
    };
  }, [popperElement]);
  useEffect(() => {
    if (isOpen) {
      setOpen(true);
    } else {
      close();
    }
  }, [isOpen]);
  const createPortal = () => {
    const div = document.createElement("div");
    div.setAttribute("id", "popper-portal");
    document.body.appendChild(div);
    return div;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(s.trigger, triggerClassName, "popup-trigger", {
        [s.active]: open,
        active: open
      }),
      ref: setReferenceElement,
      onClick: onTriggerClick,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          onTriggerClick();
        }
      },
      tabIndex: 0,
      role: "button"
    },
    trigger
  ), open ? ReactDOM.createPortal(
    /* @__PURE__ */ React.createElement(
      "div",
      {
        id,
        className: cx(s.box, className),
        ref: setPopperElement,
        style: {
          ...style,
          ...styles.popper
        },
        ...attributes.popper
      },
      children
    ),
    document.querySelector("#popper-portal") || createPortal()
  ) : null);
};
Popper.displayName = "Popper";

export { Popper };
//# sourceMappingURL=index.js.map
